export default "__VITE_ASSET__e616ba80__"